import React from 'react'

import { useTranslation } from 'react-i18next'
import { Typography } from '@material-ui/core'
import SetupTableData from '../../components/BPMTable/TableComponents/TableWrapper/SetupTableData'
import BayphoneStatusHistoryTableCreator from '../../tableDefinitions/Bayphone/BayphoneStatusHistoryTableCreator'
import tableCreatorCreatorFactoryCreator from "../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator"


export default function BayphonePopupContent (props) {
    const { t } = useTranslation()
    const filters = { bayphoneId: props.data.rawData.bayphone.id }

    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(BayphoneStatusHistoryTableCreator.getId(),  {tcFilters: filters})
    const tableCreator = tableCreatorCreator.getTableCreator('BayphoneStatusHistory')
    // Ensure required filter is always applied to the query variables
    tableCreator.setAdditionalFilters(filters)
    tableCreator.setInitialSortField('createdAt', 'asc')

    return (
        <div style={{ minHeight: '450px', maxWidth: '900px', width: '850px' }}>
            <SetupTableData
                TableCreator={tableCreator}
                stickyHeader>
                {() =>
                    <div style={{ position: 'sticky', top: 2, background: 'white', height:'35px' }}>
                        <span onClick={(event, reason) => props.close(event, reason)} style={{fontSize: '1.5em',  cursor: 'pointer', position: 'absolute', right: '5px', top: '-5px'}}>&times;</span>
                        <Typography variant="h6" style={{ marginLeft:'10px' }}>{t(`Bayphone Status History`)}</Typography>
                    </div>
                }
            </SetupTableData>
        </div>
    )
}
